import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import termsHtml from "@/src/register-company/_components/termsOfService.html?raw";

interface TermsOfServiceDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onAccept: () => void;
}

function TermsOfServiceDialog({
  open,
  onOpenChange,
  onAccept,
}: TermsOfServiceDialogProps) {
  const { t } = useTranslation();
  const [canAgree, setCanAgree] = useState(false);
  const scrollRef = useRef<HTMLDivElement | null>(null);


  useEffect(() => {
    if (!open) return;
    setCanAgree(false);
    const el = scrollRef.current;
    if (el) {
      el.scrollTop = 0;
    }
  }, [open]);

  const handleScroll = () => {
    const el = scrollRef.current;
    if (!el) return;
    const reachedEnd = el.scrollTop + el.clientHeight >= el.scrollHeight - 1;
    if (reachedEnd) setCanAgree(true);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="w-[90vw] max-w-[960px] p-0">
        <DialogHeader className="border-b px-6 py-4">
          <DialogTitle className="text-lg">
            {t("terms-of-service-agreement")}
          </DialogTitle>
        </DialogHeader>
        <div
          ref={scrollRef}
          onScroll={handleScroll}
          className="max-h-[60vh] overflow-auto px-6 py-4 text-sm text-cool-gray-700"
          dangerouslySetInnerHTML={{ __html: termsHtml }}
        />
        <DialogFooter className="flex items-center justify-end gap-3 border-t px-6 py-4">
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            {t("cancel")}
          </Button>
          <Button onClick={onAccept} disabled={!canAgree}>
            {t("agree")}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}

export default TermsOfServiceDialog;
